import { roomsGallery } from '@/mocks/rooms';

export default function RoomsGallery() {
  return (
    <section id="galerija" className="relative bg-background-100 py-16 md:py-24 lg:py-28">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-3">
              GALERIJA SOB
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-foreground-950 mb-3">
              Pogled v naše sobe
            </h2>
            <p className="font-body text-sm md:text-base text-foreground-600">
              Utrinki iz naših sob.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 auto-rows-[160px] md:auto-rows-[210px] lg:auto-rows-[230px]">
            {roomsGallery.map((slot, idx) => (
              <div
                key={idx}
                className={`rooms-gallery-item group relative overflow-hidden rounded-lg bg-background-200 ${
                  idx === 0 ? 'col-span-2 row-span-2' : ''
                }`}
              >
                <img
                  src={slot.image}
                  alt={slot.caption}
                  title={`${slot.caption} – Gostilna Marta`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4 bg-gradient-to-t from-black/55 to-transparent pointer-events-none">
                  <p className="font-label text-[10px] md:text-xs text-white/90 tracking-wide">
                    {slot.caption}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}